import { FC } from 'react';
import s from './explorePageLink.module.scss';
import Link from 'next/link';
import { CdnPath } from '@specs/cdn';
import { Dictionary, useTranslation } from '@hooks/useTranslation';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
interface Props {
  path: string;
  title: Dictionary;
  cdnPath: string;
}
export const ExplorePageLink: FC<Props> = ({
  path,
  title,
  cdnPath
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <Link href={{
    pathname: path as unknown as string
  }} className={s.exploreLink} data-sentry-element="Link" data-sentry-component="ExplorePageLink" data-sentry-source-file="ExplorePageLink.tsx">
            <h5 className={s.exploreLink__title}>{tr({
        id: title
      })}</h5>
            <OptimizedImage path={CdnPath.exploreNav} cdnId={cdnPath} fill alt={tr({
      id: 'explore.page.image.title.default'
    })} title={tr({
      id: 'explore.page.image.title.default'
    })} boxClassName={s.exploreLink__image} data-sentry-element="OptimizedImage" data-sentry-source-file="ExplorePageLink.tsx" />
        </Link>;
};